import { defineStore } from 'pinia';

import { ref, computed } from 'vue';
import { authApi } from '@/utilities/axios';
import { useAuthStore } from '@/modules/auth/store';
import { showToast } from '@/utilities/toast-handler';

const FORMULA_URL = process.env.VUE_APP_API_VERSION + '/template/formulas';

export const useFormulaStore = defineStore('formula', () => {
    const authStore = useAuthStore();
    const company_id = computed(() => {
        return authStore.getLoggedUserCompanyId;
    });

    // states
    const formula = ref(null);
    const formulas = ref([]);

    // getters
    const booleanFormulas = computed(() => {
        // console.log(formula.value);
        // return true;
        return formulas.value?.filter((formula) => formula.type === '1');
    });
    const valueFormulas = computed(() => {
        // console.log(formula.value);
        // return true;
        return formulas.value?.filter((formula) => formula.type === '2');
    });

    // actions
    const fetchFormulas = async () => {
        try {
            const response = await authApi.get(FORMULA_URL, {
                params: {
                    company_id: company_id.value,
                },
            });
            if (response.statusCode === 200) {
                formulas.value = response.data;
            }
        } catch (error) {
            showToast({}, error?.data?.message ?? 'Failed to fetch all formulas');
        }
    };

    return {
        // states
        formula,
        formulas,
        // getters
        booleanFormulas,
        valueFormulas,
        // actions
        fetchFormulas,
    };
});
